import React from 'react';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './property-type-button.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PropertyTypeButton = _ref => {
  var selected = _ref.selected,
    text = _ref.text,
    Icon = _ref.icon,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick;
  return ___EmotionJSX(Button, {
    css: styles.propertyTypeButton,
    onClick: onClick,
    iconPosition: "left",
    icon: ___EmotionJSX(Icon, {
      css: styles.icon,
      size: "custom"
    }),
    appearance: selected ? 'outlineSelected' : 'outlineTrim'
  }, text);
};
export default PropertyTypeButton;